<template>
  <div>
    <h1>{{ $t("report.newDialog.title") }}</h1>
    <v-form lazy-validation ref="form" v-model="formValid">
      <v-row>
        <v-col cols="4">
          <v-select :items="reportTypeNames" :label="$t('report.reportType')" v-model="reportForm.report_type" :rules="[requiredValidator]" />
        </v-col>
        <v-col class="px-2" cols="2">
          <v-select :items="file_formats" :label="$t('report.fileFormat')" v-model="reportForm.file_format" :rules="[requiredValidator]" />
        </v-col>
        <template v-if="reportForm.report_type !== null && reportTypeNames.find(v => v.value === reportForm.report_type).exchange" :rules="[requiredValidator]">
          <v-col class="px-2" cols="2">
            <currency-select :model.sync="reportForm.currency" :rules="[requiredValidator]" />
          </v-col>
          <v-col class="px-2" cols="2">
            <date-picker :model.sync="reportForm.exchange_rate_date" :label="$t('report.exchangeRateDate')" :rules="[requiredValidator]" />
          </v-col>
        </template>
        <v-col class="px-2" cols="2">
          <v-select :label="$t('global.numberFormat')" :items="numberFormats" v-model="reportForm.number_format_type" />
        </v-col>
      </v-row>

      <select-delegation-by-criteria-component
        :filters.sync="reportForm.criteria"
        :delegation_ids.sync="reportForm.delegation_ids"
        get-delegations-address="/report/get-delegations"
        get-filter-data-address="/report/get-filters-data"
      >
        <template v-slot:action="{ item }">
          <v-tooltip top>
            {{ $t("global.downloadFile") }}
            <template #activator="{on}">
              <v-btn icon @click="downloadDelegation(item.id)" v-on="on">
                <v-icon>mdi-file-download</v-icon>
              </v-btn>
            </template>
          </v-tooltip>
        </template>
      </select-delegation-by-criteria-component>
      <v-row>
        <v-spacer />
        <v-btn class="accent" @click="generate">{{ $t("report.newDialog.generateReportButton") }}</v-btn>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import DatePicker from "../../components/CustomInputComponents/DatePicker";
import { dateSpanTypes, reportTypeNames, reportTypes, reportFileFormats } from "../../staticData/Report";
import CurrencySelect from "../../components/CustomInputComponents/CurrencySelect";
import { requiredValidator } from "../../repository/validators";
import downloadFile from "../../repository/downloadFile";
import SelectDelegationByCriteriaComponent from "../../components/SelectDelegationByCriteriaComponent";

export default {
  name: "ReportNewView",
  components: { SelectDelegationByCriteriaComponent, CurrencySelect, DatePicker },
  data: () => ({
    formValid: false,
    reportTypes,
    dateSpanTypesConst: dateSpanTypes,
    reportForm: {
      criteria: null,
      report_type: null,
      file_format: null,
      delegation_ids: [],
      exchange_rate_date: null,
      currency: null,
      number_format_type: 0
    },
    numberFormats: [
      { text: "1234567,89", value: 0 },
      { text: "1 234 567,89", value: 1 },
      { text: "1,234,567.89", value: 2 },
      { text: "1234567.89", value: 3 }
    ]
  }),
  computed: {
    fileFormatsForSelectedReport() {
      let selectedReportType = this.reportTypeNames.find(v => v.value === this.reportForm.report_type);
      if (typeof selectedReportType === "undefined") {
        return [];
      }
      return selectedReportType.fileFormats;
    },
    file_formats() {
      let allowedFileFormats = JSON.parse(this.$store.getters["userProperties"].system_settings.allowed_report_file_formats);
      return reportFileFormats()
        .filter(v => allowedFileFormats.includes(v.value))
        .filter(v => this.fileFormatsForSelectedReport.includes(v.value));
    },
    reportTypeNames() {
      let allowedReportTypes = JSON.parse(this.$store.getters["userProperties"].system_settings.allowed_report_types);
      return reportTypeNames().filter(v => allowedReportTypes.includes(v.value));
    }
  },
  methods: {
    requiredValidator,
    downloadDelegation(id) {
      downloadFile("report/download-settlement?delegationId=" + id);
    },
    generate() {
      if (this.$refs.form.validate()) {
        if (this.reportForm.allByCriteria === true) {
          this.reportForm.delegation_ids = [];
          for (let delegation of this.filteredDelegations) {
            this.reportForm.delegation_ids.push(delegation.id);
          }
        }
        if (this.reportForm.delegation_ids.length === 0) {
          this.$store.dispatch("alertDialog", {
            content: this.$t("report.noDelegationsSelectedAlert.content"),
            title: this.$t("report.noDelegationsSelectedAlert.title")
          });
        } else {
          this.axios
            .post("/report/generate", this.reportForm)
            .then(() => {
              this.$router.push("/report");
            })
            .catch(resp => {
              if (resp.response.status === 404) {
                this.$store.dispatch("snackbarPush", {
                  text: this.$t("global.exchangeRateNotAvailable"),
                  color: "error"
                });
              }
            });
        }
      }
    }
  }
};
</script>

<style scoped>
.smaller-name {
  font-size: 12px;
}
</style>
